export default "__VITE_ASSET__DDEJIBnM__"